import React from "react";
import { Link } from "react-router-dom";
import Icons from "../icons/Icons";

const BreadCrumbs = ( props ) => {

  return (
    <nav
      className={ props.className ?? undefined }
      aria-label="breadcrumb"
    >
      <ol className='msync-breadcrumbs'>
        {
          props.breadcrumbs &&
          props.breadcrumbs.map( ( breadcrumb, index ) => (
            <li className='msync-breadcrumbs__item' key={ index } >
              { breadcrumb.link
                ? <Link 
                    to={ breadcrumb.link }
                    class={ props.breadcrumbs.length === ( index + 1 ) ? 'active msync-breadcrumbs__item__name' : 'msync-breadcrumbs__item__name' }
                  >
                    { breadcrumb.icon && <Icons type={ breadcrumb.icon } />}
                    { breadcrumb.label }
                  </Link>
                : <span class="msync-breadcrumbs__item__name">{ breadcrumb.label }</span>
              }
              { props.breadcrumbs.length !== ( index + 1 ) && <span className='msync-breadcrumbs__item__sep'><Icons type='chevron-right' /></span> }
            </li>
          ))
        }
      </ol>
    </nav>
  )
}

export default BreadCrumbs
